import { EXPLORE_ROUTES } from "../homeDashboard/exploreRoutes";
import { DASHBOARD_ROUTES } from "../homeDashboard/dashboardRoutes";
import { GAMIFICATION_ROUTES } from "../homeDashboard/gamification/gamificationRoutes";
import { AI_TUTOR_ROUTES } from "../homeDashboard/voiceChat/aiTutorRoutes";
import { EXAM_COURSE_ROUTES } from "../homeDashboard/courses/examCourseRoutes";
import React, { useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HomeDashboardLayout from "../homeDashboard/HomeDashboardLayout";

import "../dashboard/Dashboard.css";
import "../homeDashboard/HomeDashboard.css";
import "./Categories.css";
import coursesImg from "../assets/images/im1.png";
import questionBankImg from "../assets/images/im2.png";
import testsImg from "../assets/images/im3.png";
import infographicsImg from "../assets/images/im4.png";
import rapidFireImg from "../assets/images/im5.png";
import gamificationImg from "../assets/images/im6.png";
import doubtsImg from "../assets/images/im7.png";
import dailyImg from "../assets/images/im8.png";
import newsImg from "../assets/images/im3.png";
import referralImg from "../assets/images/im4.png";
import shortImg from "../assets/images/im4.png";
import podcastImg from "../assets/images/im4.png";
import flashcardImg from "../assets/images/im4.png";

import catImg1 from "../assets/images/im2.png";
import catImg2 from "../assets/images/im5.png";
import catImg3 from "../assets/images/im6.png";
import { useDashboardCategories } from "../hooks/useDashboardCategories";
import QuizCategory from "./QuizCategory";
import { CONTENT_ROUTES } from "../homeDashboard/contentRoutes";
import { REFERRAL_ROUTES } from "../homeDashboard/referralEarn/referralRoutes";

const HeaderProfileSection = () => null;
const DEFAULT_STATE_ID = 13;
const QUIZ_CATEGORY_ID = 1;
const QUESTION_BANK_CATEGORY_ID = 2;
const RAPID_FIRE_CATEGORY_ID = 5;
const NOTES_CATEGORY_ID = 4;
const GAMIFICATION_CATEGORY_ID = 6;
const COURSES_CATEGORY_ID = 7;
const ARTICLES_CATEGORY_ID = 8;
const FLASH_CARDS_CATEGORY_ID = 9;
const INFOGRAPHICS_CATEGORY_ID = 13;
const DAILY_QUESTIONS_CATEGORY_ID = 14;
const REFERRAL_CATEGORY_ID = 11;

const fallbackImages = [
  coursesImg,
  questionBankImg,
  testsImg,
  infographicsImg,
  rapidFireImg,
  gamificationImg,
  doubtsImg,
  dailyImg,
  newsImg,
  referralImg,
  podcastImg,
  shortImg,
  flashcardImg,
];

function normalizeColorCode(value) {
  if (!value) {
    return null;
  }

  return `#${String(value).replace(/^#/, "")}`;
}

const fallbackThemes = [
  "cyan",
  "purple",
  "yellow",
  "cyan",
  "light-pink",
  "blue",
  "lavender",
  "soft-pink",
  "rose",
  "green",
  "light-pink",
  "cyan",
  "yellow",
];

const PODCAST_CATEGORY_ID = 12;
const AI_TUTOR_CATEGORY_ID = 15;

function resolveCategoryRoute(item) {
  const routeKey = `${item?.route_key ?? ""}`.trim().toLowerCase();
  const slug = `${item?.slug ?? item?.category_slug ?? ""}`.trim().toLowerCase();
  const title = `${item?.title ?? item?.category_name ?? item?.name ?? ""}`.trim().toLowerCase();
  const categoryId = Number(item?.category_id || item?.id || 0);

  if (categoryId === REFERRAL_CATEGORY_ID) {
    return REFERRAL_ROUTES.home;
  }

  if (categoryId === AI_TUTOR_CATEGORY_ID || slug === "ai-tutor" || slug === "aitutor" || slug === "voice-chat" || title.includes("ai tutor")) {
    return AI_TUTOR_ROUTES.voiceChat;
  }

  if (routeKey === "11" || slug === "referral-earn" || slug === "refer-and-earn" || title.includes("referral")) {
    return REFERRAL_ROUTES.home;
  }

  if (
    categoryId === RAPID_FIRE_CATEGORY_ID ||
    routeKey === "5" ||
    slug === "rapidfire" ||
    title.includes("rapid fire")
  ) {
    return EXPLORE_ROUTES.subjects;
  }
  if (
    categoryId === GAMIFICATION_CATEGORY_ID ||
    slug === "gamification" ||
    title.includes("gamification")
  ) {
    return GAMIFICATION_ROUTES.start;
  }

  if (categoryId === COURSES_CATEGORY_ID || slug === "courses" || title === "courses") {
    return EXAM_COURSE_ROUTES.masterExams;
  }


  if (
    categoryId === NOTES_CATEGORY_ID ||
    routeKey === "4" ||
    slug === "notes" ||
    title.includes("notes")
  ) {
    return EXPLORE_ROUTES.subjects;
  }

  if (
    categoryId === 3 ||
    routeKey === "3" ||
    slug === "lectures" ||
    title.includes("lectures")
  ) {
    return EXPLORE_ROUTES.subjects;
  }

  if (
    categoryId === QUESTION_BANK_CATEGORY_ID ||
    routeKey === "2" ||
    slug === "mcqbank" ||
    title.includes("question bank")
  ) {
    return EXPLORE_ROUTES.subjects;
  }

  if (categoryId === FLASH_CARDS_CATEGORY_ID || slug === "flash-cards" || title.includes("flash card")) {
    return EXPLORE_ROUTES.subjects;
  }

  if (categoryId === INFOGRAPHICS_CATEGORY_ID || slug === "infographics" || title.includes("infographic")) {
    return EXPLORE_ROUTES.subjects;
  }

  if (categoryId === DAILY_QUESTIONS_CATEGORY_ID || slug === "daily-questions" || title.includes("daily question")) {
    return CONTENT_ROUTES.dailyQuestions;
  }

  if (categoryId === PODCAST_CATEGORY_ID || slug === "podcasts" || title.includes("podcast")) {
    return EXPLORE_ROUTES.subjects;
  }

  if (
    categoryId === ARTICLES_CATEGORY_ID ||
    routeKey === "8" ||
    slug === "blogs" ||
    title.includes("news") ||
    title.includes("article")
  ) {
    return CONTENT_ROUTES.articles;
  }

  if (categoryId === 10 || slug === "doubts" || title.includes("doubt")) {
    return "/doubts";
  }

  return EXPLORE_ROUTES.exams;
}

const Categories = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isQuizCategoryOpen, setIsQuizCategoryOpen] = useState(false);
  const selectedState = location.state?.selectedState || null;
  const stateId = Number(selectedState?.state_id || location.state?.state_id || DEFAULT_STATE_ID);
  const {
    data: categoriesData,
    isLoading,
    isFetching,
    isError,
    error,
  } = useDashboardCategories(
    {
      states_id: stateId,
    },
    {
      enabled: Number.isFinite(stateId) && stateId > 0,
    }
  );
  const categories = useMemo(
    () =>
      (categoriesData?.categories || []).map((item, index) => ({
        id: item?.category_id || item?.id || index + 1,
        title: item?.title || item?.category_name || item?.name || "Category",
        description:
          item?.description ||
          item?.category_description ||
          item?.sub_title ||
          "Explore this learning category.",
        image: item?.category_image || item?.image || fallbackImages[index % fallbackImages.length],
        theme: fallbackThemes[index % fallbackThemes.length],
        backgroundColor: normalizeColorCode(item?.background_color_code),
        borderColor: normalizeColorCode(item?.border_color_code),
        path: resolveCategoryRoute(item),
        source: item,
      })),
    [categoriesData?.categories]
  );
  const quizCategories = categoriesData?.quizCategories || [];
  const stateName =
    categoriesData?.stateName ||
    selectedState?.state_name ||
    selectedState?.stateName ||
    "Himachal Pradesh";
  const dashboardStatesNavigationState = useMemo(
    () => ({
      state_id: stateId,
      selectedState: {
        state_id: stateId,
        state_name: stateName,
      },
    }),
    [stateId, stateName]
  );
  const loadError = isError
    ? error?.response?.data?.message || error?.message || "Unable to load categories."
    : "";
  const isCategoriesPending = isLoading || isFetching;

  const handleCardClick = (item) => {
    const categoryId = Number(item?.source?.category_id || item?.source?.id || item?.id || 0);
    const title = `${item?.title || ""}`.trim().toLowerCase();

    if (categoryId === QUIZ_CATEGORY_ID || title.includes("tests") || title.includes("quiz")) {
      setIsQuizCategoryOpen(true);
      return;
    }

    if (item.path) {
      navigate(item.path, {
        state: {
          selectedState: {
            state_id: stateId,
            state_name: stateName,
          },
          selectedCategory: item.source,
          gamificationBackTarget:
            item.path === GAMIFICATION_ROUTES.start
              ? {
                  pathname: EXPLORE_ROUTES.categories,
                  state: {
                    selectedState: {
                      state_id: stateId,
                      state_name: stateName,
                    },
                  },
                }
              : undefined,
          articlesBackTarget:
            item.path === CONTENT_ROUTES.articles
              ? {
                  pathname: EXPLORE_ROUTES.categories,
                  state: {
                    selectedState: {
                      state_id: stateId,
                      state_name: stateName,
                    },
                  },
                }
              : undefined,
        },
      });
    }
  };

  return (
    <>
      <style>
        {`
          .homeDashboard-wrapper .page-content {
            padding-right: 0;
          }

          .layout-wrapper.homeDashboard-wrapper {
            background: #ffffff;
          }
        `}
      </style>

      <HomeDashboardLayout showHeader={false}>
        <div className="categories-page">
          <div className="categories-page-header">
            <div>
                <button
                type="button"
                className="categories-back-button"
                onClick={() =>
                  navigate(DASHBOARD_ROUTES.states, {
                    state: dashboardStatesNavigationState,
                    replace: true,
                  })
                }
                aria-label="Go back"
                >
                <i className="bi bi-chevron-left"></i>
                </button>
            </div>
           <div>
            <h1 className="categories-page-title">
              {stateName}
            </h1>
           </div>
            <div>
               <HeaderProfileSection/>
            </div>
          </div>

          <section className="categories-intro">
            <div className="categories-intro-content">
              <p className="categories-greeting">
                Hello Aspirant!
              </p>

              <h2 className="categories-heading">
                What would you like to explore today?
              </h2>

              <p className="categories-description">
                All the tools you need for your preparation, in one place.
              </p>
            </div>

            <div className="categories-intro-image">
              <img
                src={catImg1}
                alt=""
                aria-hidden="true"
              />
               <img
                src={catImg2}
                alt=""
                aria-hidden="true"
              />
               <img
                src={catImg3}
                alt=""
                aria-hidden="true"
              />
            </div>
          </section>

          <section
            className="categories-module-section"
            aria-label="Study tools"
          >
            {isCategoriesPending ? (
              <div className="categories-module-grid" aria-hidden="true">
                {Array.from({ length: 8 }).map((_, index) => (
                  <div key={index} className={`category-module-card category-module-card--${fallbackThemes[index % fallbackThemes.length]}`}>
                    <span className="category-module-card__image-wrapper">
                      <span className="dashboard-skeleton dashboard-skeleton--thumb category-module-card__image" />
                    </span>
                    <span className="category-module-card__content" style={{ width: "100%" }}>
                      <span className="dashboard-skeleton dashboard-skeleton--line dashboard-skeleton--title" />
                      <span className="dashboard-skeleton dashboard-skeleton--line dashboard-skeleton--text" />
                    </span>
                  </div>
                ))}
              </div>
            ) : null}
            {!isCategoriesPending && loadError ? <p className="choose-state__status choose-state__status--error">{loadError}</p> : null}
            {!isCategoriesPending && !loadError && !categories.length ? (
              <p className="choose-state__status">No categories available.</p>
            ) : null}
            {!isCategoriesPending && !loadError && categories.length ? (
              <div className="categories-module-grid">
                {categories.map((item) => (
                  <button
                    type="button"
                    key={item.id}
                    className={`category-module-card category-module-card--${item.theme}`}
                    style={{
                      background: item.backgroundColor
                        ? `linear-gradient(180deg, ${item.backgroundColor} 0%, #ffffff 140%)`
                        : undefined,
                      borderColor: item.borderColor || undefined,
                    }}
                    onClick={() => handleCardClick(item)}
                    aria-label={`Open ${item.title}`}
                  >
                    <span className="category-module-card__image-wrapper">
                      <img
                        src={item.image}
                        alt=""
                        className="category-module-card__image"
                      />
                    </span>

                    <span className="category-module-card__content">
                      <span className="category-module-card__title">
                        {item.title}
                      </span>

                      <span className="category-module-card__description">
                        {item.description}
                      </span>
                    </span>
                  </button>
                ))}
              </div>
            ) : null}
          </section>
        </div>
        <QuizCategory
          open={isQuizCategoryOpen}
          onClose={() => setIsQuizCategoryOpen(false)}
          quizCategories={quizCategories}
          navigationState={{
            selectedState: {
              state_id: stateId,
              state_name: stateName,
            },
            selectedCategory: {
              title: "Tests & Quizzes",
            },
          }}
        />
      </HomeDashboardLayout>
    </>
  );
};

export default Categories;











